import InfoIcon from '@mui/icons-material/Info';
import { Grid, Box, ListItemText, ListItemButton, IconButton, Tooltip } from '@mui/material';
import {
  WsChip,
  WsChipVariants,
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { IPremiumJobBoard } from '../../../../../features/jobs/utils/JobListSideNavHelper';

interface ISideNavJobBoardItemProps {
  jobBoard: IPremiumJobBoard;
  onJobBoardClick: (jobBoardName: string) => void;
}

const SideNavJobBoardItem = ({ jobBoard, onJobBoardClick }: ISideNavJobBoardItemProps) => (
  <ListItemButton onClick={() => onJobBoardClick(jobBoard.name)}>
    <ListItemText
      primary={
        <Grid direction="row" alignItems="center" container>
          <Grid item>
            <Box pr={1}>{jobBoard.icon}</Box>
          </Grid>
          <Grid item>
            <WsTypography
              variant={WsTypoVariants.BODY2}
              color={WsTypoColors.BLACK}
              cursor="pointer"
            >
              {jobBoard.name}
            </WsTypography>
          </Grid>
          {jobBoard.name === 'Dice' && (
            <Tooltip title="Allocated job posting credits can be reused by published and unpublishing the jobs at any given time Ex: If you publish a job and received new job to work on, you can unpublish the current job and can use the same credit to publish the new job">
              <IconButton>
                <InfoIcon style={{ color: WsColors.TheBlues300, fontSize: 19 }} />
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      }
    />
    <WsChip
      value={`${jobBoard.usedCredits}/${jobBoard.availableCredits}`}
      variant={WsChipVariants.PRIMARY}
      isPointer={true}
      tooltipText={jobBoard.usedCredits + ' of ' + jobBoard.availableCredits + ' used'}
    />
  </ListItemButton>
);
export default SideNavJobBoardItem;
